import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  flex: 1;
`;

const Spinner = styled.div`
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid var(--tertiary-green);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

interface LoaderProps {
  isSmall?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isSmall }) => {
  return (
    <LoaderWrapper style={{ height: isSmall ? "auto" : "100px" }}>
      <Spinner
        style={{
          height: isSmall ? "10px" : "30px",
          width: isSmall ? "10px" : "30px",
        }}
      />
    </LoaderWrapper>
  );
};

export default Loader;
